import {useRef,useEffect, useState} from 'react';

import {Dialog} from 'primereact/dialog';
import {Button} from 'primereact/button';

import {ToastService} from '../../../AppToast';
import {useForm} from '../../../shared/hooks/Form';
import  EventEmitter  from '../../../utils/EventEmitter';
import {useTranslation} from '../../../shared/language';
export const useDialogChangeInvoiceSerial = (props) => {
  const {t} = useTranslation();

  const input = useRef(null);

  const {registerInvoices, registerInvoice} = props;
  const [registerInvoiceOptions, setRegisterInvoiceOptions] = useState([]);
  const [display, setDisplay] = useState(false);
  const [invoiceSerials, setInvoiceSerials] = useState([]);
  const [submitting, setSubmitting] = useState(false);

  const showChangeSerialDialog = () => {
    const _invoiceSerials = [];
    registerInvoices.forEach(item => {
      _invoiceSerials.push({value: item.symbolCode, label: item.label});
    });
    setInvoiceSerials(_invoiceSerials);
    setDisplay(true);
  }

  const setRegisterInvoice = () =>{
  }

  const handleSubmit = () => {
    const changeSerialData = getValue();
    EventEmitter.emit("changeInvoiceSerial", changeSerialData);
    setDisplay(false);
  }

  useEffect(() => {
    if (display) {
      setValue({
        invoiceSerial: registerInvoice.symbolCode,
      });
    }
  }, [display]); // eslint-disable-line react-hooks/exhaustive-deps

  const {render: renderForm, setValue, getValue} = useForm({
    fields: [
      {field: 'invoiceSerial', header: t('common.oldSymbol'), type: 'Dropdown', DropdownProps: {options: invoiceSerials, filter: true, resetFilterOnHide: true}, className: 'md:col-12', labelClassName: 'md:col-3', inputClassName: 'md:col-9'},
      {field: 'invoiceSerialRepalce', header: t('common.newSymbol'), type: 'Dropdown', DropdownProps: {options: invoiceSerials, filter: true, resetFilterOnHide: true}, className: 'md:col-12', labelClassName: 'md:col-3', inputClassName: 'md:col-9'},
    ],
    layout: 'Horizontal'
  });

  useEffect(() => {

  },[registerInvoices])

  const renderChangeSerial = () => {
    return (
      <Dialog header={t('common.changeInvoiceSerial')} visible={display} style={{width: '40rem'}} position="top" onHide={() => setDisplay(false)}>
        <div className="p-fluid formgrid grid">
          <div className="col-11">
            {renderForm()}
          </div>
        </div>

        <div className="flex justify-content-end">
          <Button label={t('common.execute')} icon="pi pi-sync" onClick={handleSubmit} loading={submitting} className="p-button-sm mr-2"/>
          <Button label={t('common.close')} icon="pi pi-times" onClick={() => setDisplay(false)} className="p-button-sm p-button-raised p-button-text p-button-plain"/>
        </div>
      </Dialog>
    );
  }

  return {renderChangeSerial, showChangeSerialDialog, setValue};

}
